export const SYSTEM_COMPONENT_DEVICE_STATE_ADD =
  "SYSTEM_COMPONENT_DEVICE_STATE_ADD";
export const SYSTEM_COMPONENT_DEVICE_STATE_REMOVE =
  "SYSTEM_COMPONENT_DEVICE_STATE_REMOVE";

export const DEVICE_COMPONENT_LIST_FETCH_REQUEST =
  "DEVICE_COMPONENT_LIST_FETCH_REQUEST";
export const DEVICE_COMPONENT_LIST_FETCH_SUCCESS =
  "DEVICE_COMPONENT_LIST_FETCH_SUCCESS";
export const DEVICE_COMPONENT_LIST_FETCH_ERROR =
  "DEVICE_COMPONENT_LIST_FETCH_ERROR";

export const FETCHING_STATUS = "FETCHING";
export const SUCCESS_STATUS = "SUCCESS";
export const ERROR_STATUS = "ERROR";

export const GENERIC_ERROR_MESSAGE =
  "Failed - Due to Technical error, Please try again";

export const CHANGE_SELECTED_FILTER_VALS = "CHANGE_SELECTED_FILTER_VALS";

export const CHANGE_SELECTED_COMPONENT = "CHANGE_SELECTED_COMPONENT";

export const COMPONENT_METRICS_FETCH_REQUEST =
  "COMPONENT_METRICS_FETCH_REQUEST";
export const COMPONENT_METRICS_FETCH_SUCCESS =
  "COMPONENT_METRICS_FETCH_SUCCESS";
export const COMPONENT_METRICS_FETCH_ERROR = "COMPONENT_METRICS_FETCH_ERROR";

export const CHANGE_SELECTED_COMPONENT_METRIC =
  "CHANGE_SELECTED_COMPONENT_METRIC";
export const CHANGE_SELECTED_DATE_RANGE = "CHANGE_SELECTED_DATE_RANGE";

export const COMPONENT_MEASUREMENT_VALS_FETCH_REQUEST =
  "COMPONENT_MEASUREMENT_VALS_FETCH_REQUEST";
export const COMPONENT_MEASUREMENT_VALS_FETCH_SUCCESS =
  "COMPONENT_MEASUREMENT_VALS_FETCH_SUCCESS";
export const COMPONENT_MEASUREMENT_VALS_FETCH_ERROR =
  "COMPONENT_MEASUREMENT_VALS_FETCH_ERROR";

export const MEASUREMENT_DATE_TIME_FORMAT = "MM/DD/YYYY hh:mm:ss A";

export const MEASUREMENT_GRAPH_TITLE = "Total Measurements";
export const MEASUREMENT_GRAPH_XAXIS_TITLE = "Date Range";
export const MEASUREMENT_GRAPH_YAXIS_TITLE = "Units";
